<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { baseUrl } from '@/core/utils'
import { useLocationDialog, type LocationDialogProps } from '../../composables/dialog/useLocationDialog'
import { useLocationDialogWithTimeout } from '../../composables/dialog/useLocationDialogWithTimeout';

const props = withDefaults(defineProps<LocationDialogProps>(), {
  autoOpen: false,
})

const { id, data, opened, close, currentIndex, showNext, showPrev, next, prev } = useLocationDialogWithTimeout(props)

</script>

<template>
  <transition name="fade-dialog">
    <div v-show="opened" ref="location" :id class="location-dialog">
      <!-- preview-section -->
      <section class="preview-section">
        <!------------------------------------->
        <template v-for="(d, i) in data">
          <transition name="fade">
            <template v-if="d.preview.endsWith('.mp4') || d.preview.endsWith('.webm')" :key="d.preview">
              <video v-show="i == currentIndex" :index="i" class="preview" :src="baseUrl(d.preview)" preload="auto"></video>
            </template>
            <template v-else>
              <img v-show="i == currentIndex" :index="i" class="preview" :src="baseUrl(d.preview)" />
            </template>
          </transition>
        </template>
        <!------------------------------------->
        <img v-show="showPrev" class="prev" src="/images/button-prev.png" @pointerdown="prev" />
        <img v-show="showNext" class="next" src="/images/button-next.png" @pointerdown="next" />
      </section>
      <!-- caption-section -->
      <section class="caption-section">
        <!------------------------------------->
        <template v-for="(d, i) in data">
          <transition name="fade">
            <!-- prettier-ignore -->
            <img v-show="i == currentIndex" :index="i" :key="i" class="caption" :src="baseUrl(d.caption)" />
          </transition>
        </template>
        <!------------------------------------->
        <img class="close" src="/images/button-close.png" @pointerdown="close" />
      </section>
    </div>
  </transition>
</template>

<style scoped>
/* ------------------------ */
.fade-dialog-enter-active,
.fade-dialog-leave-active {
  transition: opacity 0.3s ease;
}
.fade-dialog-enter-from,
.fade-dialog-leave-to {
  opacity: 0;
}

/* ------------------------ */
.location-dialog {
  position: absolute;
  left: 665px;
  top: 1627px;
}

/* ------------------------ */
.location-dialog.layout-left .caption-section {
  left: 0;
  animation: slideInLeft 0.5s ease-in-out forwards;
}

.location-dialog.layout-left .caption-section .close {
  position: absolute;
  top: 13px;
  left: 13px;
  cursor: pointer;
}

/* ------------------------ */
.location-dialog.layout-right .caption-section {
  right: 0;
  animation: slideInRight 0.5s ease-in-out forwards;
}

.location-dialog.layout-right .caption-section .close {
  position: absolute;
  top: 12px;
  left: 565px;
  cursor: pointer;
}

/* ------------------------ */
.location-dialog.layout-right2 .caption-section {
  right: 0;
  animation: slideInRight2 0.5s ease-in-out forwards;
}

.location-dialog.layout-right2 .caption-section .close {
  position: absolute;
  top: 12px;
  left: 565px;
  cursor: pointer;
}

/* ------------------------ */
.preview-section {
  position: relative;
  width: 685px;
  height: 415px;
  z-index: 11;
  background-image: url(/images/location/preview-bg.png);
}

.preview-section .preview {
  position: absolute;
  width: 619px;
  height: 349px;
  top: 31px;
  left: 31px;  
}

.preview-section .prev {
  position: absolute;
  left: 35px;
  top: 330px;
  cursor: pointer;
}

.preview-section .next {
  position: absolute;
  left: 595px;
  top: 330px;
  cursor: pointer;
}

/* ------------------------ */
.caption-section {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto 0;
  width: 620px;
  height: 360px;
  background-image: url(/images/location/caption-bg.png);
  z-index: 10;
}

.caption-section .caption {
  position: absolute;
}

/* ------------------------ */
/* prettier-ignore */
@keyframes slideInLeft {
  from { left: 0; }
  to { left: -564px; }
}
/* prettier-ignore */
@keyframes slideInRight {
  from { right: 0; }
  to { right: -564px; }
}
/* prettier-ignore */
@keyframes slideInRight2 {
  from { right: 0; }
  to { right: -503px; }
}
/* ------------------------ */
</style>
